<template lang="pug">
  .quotation-list
    template(v-for="item in data")
      el-row
        el-col(:span="4") {{ $t('Sub SOW') }}
        el-col(:span="20") {{ item.sub_final_scope_name }}
      el-row
        el-col(:span="4") {{ $t('供应商') }}
        el-col(:span="20") {{ item.price.vendor_name_ch + '/' + item.price.vendor_name }}
      el-row
        el-col(:span="4") {{ $t('方案') }}
        el-col(:span="20")
          a(:href="item.price.project_download_path" download) {{ item.price.project_name }}
      el-row
        el-col(:span="4") {{ $t('报价') }}
        el-col(:span="20")
          el-button(@click="onDetailView(item.sub_final_scope_vendor_id)") {{ $t('查看明细') }}
      el-row
        el-col(:span="19" :offset="4")
          QuotationOverview(:data="item.price.price_overview")
      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="20") {{ item.remark || '—' }}

    quotation-dialog(
      v-model="dialogVisible"
      :id="quotationId"
    )
</template>

<script>
import QuotationOverview from '@/components/QuotationOverview'
import QuotationDialog from './QuotationDialog'

export default {
  components: {
    QuotationOverview,
    QuotationDialog
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      quotationId: null,
      dialogVisible: false
    }
  },
  computed: {
    isDemoUser () {
      // return this.$store.state.common.user.company_name === '联合利华集团'
      return this.$store.state.common.user.company_name === 'Mccann'
    }
  },
  methods: {
    onDetailView (id) {
      this.dialogVisible = true
      this.quotationId = id
    }
  }
}
</script>
